import React from "react";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";

interface CommonHeaderProps {
  column: string;
  data: { values: Record<string, any>[] };
  sortState: { heading: string; sortType: "asc" | "desc"} | any; 
    // secondarySort?: { heading: string; sortType: string }  | null;
  onSort: (heading: string, sortType: "asc" | "desc") => void;
}

const FaSortUpComponent = FaSortUp as React.ComponentType<{
  className?: string;
  title?: string;
  onClick?: () => void;
}>;
const FaSortDownComponent = FaSortDown as React.ComponentType<{
  className?: string;
  title?: string;
  onClick?: () => void;
}>;
const FaSortComponent = FaSort as React.ComponentType<{
  className?: string;
  title?: string;
  onClick?: () => void;
}>;

const formatHeader = (header: string): string => {
  return header
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const CommonHeader: React.FC<CommonHeaderProps> = ({
  column,
  data,
  sortState,
  onSort,
}) => {
  const normalizeKey = (key: string) =>
  key.toLowerCase().replace(/[_\s]/g, ""); // removes underscores and spaces

  // const titleKey =
  //   Object.keys(data?.values?.[0] || {}).find(
  //     (key) => key === column || data.values[0][key] === column
  //   ) || column;
  const titleKey=column

  const isActiveSort = sortState?.heading === titleKey;
  console.log(isActiveSort, titleKey, "titlekey");
  return (
    <div className="flex items-center justify-center">
      <span>{formatHeader(column)}</span>
      <span className="ml-1 mt-1">
        {isActiveSort && sortState?.sortType === "desc" ? (
          <FaSortUpComponent
            title={`sort ${column} by ascending`}
            className="cursor-pointer"
            onClick={() => onSort(titleKey, "asc")}
          />
        ) : isActiveSort && sortState?.sortType === "asc" ? (
          <FaSortDownComponent
            title={`sort ${column} by descending`}
            className="cursor-pointer"
            onClick={() => onSort(titleKey, "desc")}
          />
        ) : (
          <FaSortComponent
            title={`sort ${column} by ascending`}
            className="cursor-pointer"
            onClick={() => onSort(titleKey, "asc")}
          />
        )}
      </span>
    </div>
  );
};

export default CommonHeader;